/**
 * 购物车和个人中心公共工具函数
 * 用于替代 ShoppingCartMod 和 PersonalMod，避免在首页引入完整的 Mod
 */
import Request from 'utils/request';
import config from 'config/Config';

/**
 * 获取未读消息数量
 * @returns {Promise<number>} 未读消息总数
 */
export async function getMsgCount() {
  try {
    const { data } = await Request({
      url: 'message/queryNoReadMessageCount',
      host: config.HOST_MALL,
      ignore401: true
    });
    return +data.actNoReadcount + +data.orderNoReadcount + +data.sysNoReadcount;
  } catch (error) {
    console.error('获取消息数量失败:', error);
    return 0;
  }
}

/**
 * 添加商品到购物车
 * @param {Object|Array} params - 商品参数
 * @param {string} params.itemSerial - 商品编号
 * @param {string} params.itemName - 商品名称
 * @param {number} params.itemNum - 商品数量
 * @param {number} params.price - 商品价格
 * @param {number} params.fromActiveSource - 来源（1=宫主会）
 * @returns {Promise<boolean>} 是否成功
 */
export async function addCart(params) {
  const shareId = localStorage.getItem('shareIdVistor') || void 0;
  const data = Array.isArray(params) ? params : { ...params, shareId };

  try {
    // 确定接口地址
    let url = `tradecore/trolley/item/add`;
    if (Array.isArray(data)) {
      url = `tradecore/trolley/item/batch/add`;
    } else {
      if (data.fromActiveSource == 1) {
        // 宫主会地址
        url = `tradecore/priaPoints/trolley/item/add/2`;
      }
    }

    // 调用接口
    await Request({
      url: url,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });

    // 神策数据埋点
    if (window.sensors) {
      window.sensors.track('shopcartAdd', {
        arr: JSON.stringify([
          {
            commodity_id: params.itemSerial,
            commodity_name: params.itemName,
            quantity: params.itemNum || '',
            price: params.price || '',
            source: 'H5'
          }
        ])
      });
    }

    return true;
  } catch (error) {
    console.error('添加购物车失败:', error);
    return false;
  }
}

/**
 * 添加商品到甄选商城购物车
 * @param {Object} data - 商品参数
 * @param {number} type - 类型（0=积分商城，1=异业商城）
 * @returns {Promise<boolean>} 是否成功
 */
export async function addSelectMallCart(data, type) {
  try {
    await Request({
      url: `tradecore/integral/trolley/item/add/${type}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
    return true;
  } catch (error) {
    console.error('添加甄选商城购物车失败:', error);
    return false;
  }
}

/**
 * 获取用户是否需要完善资料
 * @returns {Promise<Object|null>} 返回完善资料信息，如果不需要完善则返回 null
 */
export async function getUserShouldSupply() {
  try {
    const { data } = await Request({
      url: 'user/info/getUserShouldSupply',
      host: config.HOST_MALL,
      method: 'get'
    });
    return data;
  } catch (error) {
    console.error('获取完善资料信息失败:', error);
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/shoppingCart.js